<template>
  <div id="task-details-dashboard" class="w-full" v-if="isCardActiveLocal">
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <user-details :loading="loadingDetails" :userDetails="userDetails" :myTime="userDetailsObject.timeSpentAvarageStudent" :avgTime="userDetailsObject.timeSpentAvarageClass" :radialData="[userDetailsObject.scoreAvarageStudent,userDetailsObject.scoreAvarageClass]"/>
      </div>
    </div>
    <div class="flex mb-2" style="justify-content: space-between;">
      <div class="flex" style="align-items: center;">
        <h4 style="margin-bottom: 0;">{{userDetails.selectedTask.name}}</h4>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="text-left">
          <h5 class="data-my-avg mt-3">Highest score</h5>
          <h5 class="data-avg">Average score</h5>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div v-if="!taskAttemptLoading && (heighestScore || averageScore)" class="vx-col w-full xl:w-1/3 lg:w-1/2">
        <custom-radial-chart class="radial-move" height="250" width="300" :series="[heighestScore,averageScore]" />
      </div>
      <div v-if="taskAttemptLoading" class="vx-col w-full xl:w-1/3 lg:w-1/2">
        <custom-skeleton class="loading-to-the-right mt-5 mr-5" animation="wave" type="avatar" :count="1" height="175px" width="175px"/>
      </div>
      <div class="vx-col w-full xl:w-2/3 lg:w-1/2 self-center flex">
        <div v-if="!taskAttemptLoading" id="prototype" class="vx-row">
          <div class="vx-col mb-3"  v-for="(attempt, index) in taskAttempts" :key="index" style="min-width: 210px;max-width: 210px;">
            <vx-card style="border-radius: 30px;" class="hover_on-mouseover">
              <div style="overflow: hidden;height: 40px;">
                <h5 class="mb-2">Attempt {{ (index + 1) }}</h5>
              </div>
              <span class="flex mb-2" style="align-items: center;">
                <feather-icon icon="CheckIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>
                <vs-progress v-if="(attempt.totalMarks != null && attempt.achievedMarks != null)" :height="16" :percent="(attempt.achievedMarks / attempt.totalMarks) * 100" show-value color="success" style="text-align: start;"/>
                <p v-if="(attempt.totalMarks != null && attempt.achievedMarks != null)" class="ml-2" style="margin-top: -0.1rem !important; width:23px">
                  <strong>{{ attempt.totalMarks ? `${Math.round((attempt.achievedMarks / attempt.totalMarks) * 100, 2)}%` : "0%" }}</strong>
                </p>
                <div class="w-full" v-else>
                  <p>
                    <strong>N/A</strong>
                  </p>
                </div>
              </span>
              <span class="flex" style="align-items: center;"><feather-icon icon="ClockIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>{{ attempt.completedDate.replace("T", " ").split('.')[0] }}</span>
              <vs-spacer />
              <div class="w-full mb-2" style="height: 18px;">
                <vs-chip class="w-full mt-2" :color="attempt.statusId == 1 ? 'success' : 'primary'">{{attempt.statusDisplayName == 'Completed' && $getSiteId() == 21 ? 'Submitted' :attempt.statusDisplayName  }}</vs-chip>
              </div>
            </vx-card>
          </div>
        </div>
        <custom-skeleton v-if="taskAttemptLoading" class="attempt-loader" :count="1" animation="wave" type="text" width="160px" height="160px"></custom-skeleton>
        <div v-if="!taskAttempts.length && !taskAttemptLoading">
          <div class="vx-row">
            <div>
              <h3 class="mr-4" >No data</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import UserDetails from './UserDetails.vue'
import CustomSkeleton from './CustomSkeleton.vue'
import DataCardSkeleton from './DataCardSkeleton.vue'
import CustomRadialChart from './CustomRadialChart.vue'
export default {
  name: "TaskDetails",
  components: {
    vSelect,
    UserDetails,
    CustomSkeleton,
    DataCardSkeleton,
    CustomRadialChart
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
    userDetails:{
      type:Object,
      required: true
    }
  },
  data() {
    return {
      loadingDetails:true,
      taskAttempts: [],
      userDetailsObject:{},
      heighestScore:0,
      averageScore:0,
      taskAttemptLoading:true,
    };
  },
  watch: {
    isCardActive: function(val) {
      var self = this;
      if(val){
        self.getTaskAttempts();
        self.fetchUserDetails();
        localStorage.setItem("Teacher_Position",JSON.stringify(self.userDetails));
        localStorage.setItem("Active_Card","8");
      }
    },
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) { }
    },
  },
  methods: {
    getTaskAttempts() {
      var self = this;
      self.taskAttemptLoading = true;

      var onSuccess = function(response) {
        if(!response.data.taskAttempts){
          return;
        }
        self.heighestScore = response.data.highestMark;
        self.averageScore = response.data.averageMark;
        self.taskAttempts = [];
        response.data.taskAttempts.forEach(element => {
          self.taskAttempts.push(
          {
            totalMarks: element.totalMarks,
            achievedMarks: element.achievedMarks,
            statusId: element.statusId,
            statusDisplayName: element.statusDisplayName,
            completedDate: element.completedDate
          })
        });
      };

      var onFinally = function() {
        self.taskAttemptLoading = false;
      };
      self.$ajaxGet(self,`TeacherDashboard/GetStudentTaskAttempts?studentId=${self.userDetails.selectedStudent.studentId}&taskId=${this.userDetails.selectedTask.id}`, onSuccess, onFinally);
    },
    fetchUserDetails() {
      var self = this;
      this.loadingDetails = true;
      var onSuccess = response =>{
        self.userDetailsObject = response.data;
        self.loadingDetails = false;
      }
      var onFinally = response =>{
        self.loadingDetails = false;
      }
      self.$ajaxGet(self, `TeacherDashboard/UserDetails?studentId=${self.userDetails.selectedStudent.studentId}&classroomId=${this.userDetails.selectedClassroom.classroomId}&moduleCategoryId=${this.userDetails.selectedModule.moduleCategoryId}&moduleId=${this.userDetails.selectedTopic.id}&taskId=${self.userDetails.selectedTask.id}`, onSuccess, onFinally);

    },
  },
  created() {
    
  },
  mounted() {
  }
};
</script>

<style lang="scss">
#task-details-dashboard {
  .data-my-avg::before{
    background-color: rgba(var(--vs-primary),100)
  }
  .data-avg::before{
    background-color: white;
  }
  h5::before{
    content: '';
    border-radius: 50%;
    height: 15px;
    width: 15px;
    margin-right: 5px;
    display: inline-block;
  }
  .primary-color{
    color: rgba(var(--vs-primary),100)
  }
  @media screen  and(max-width:434px){
    #prototype{
      justify-content: center;
    }
  }
}
.loading-to-the-right{
  margin-left: -30px;
}
</style>
